export default "__VITE_ASSET__OIRCQBZO__"